/*
 * 「お風呂を学ぶ」メール登録バナー（2026-10-15〜）
 * 商品ページ下部・記事ページ末尾・TOP中段（記事リストの下）に、松永さんの写真つきのカードを差し込む。
 * 表示（半分以上が約1秒見えた）とクリックを BATHLIER HUB（検定バナーと同じ受け口）へ送る。variant は 'M'。
 * 設定は window.LMB（snippets/learn-mail.liquid）で渡す。確認用：URL に ?lmb=1 を付けると計測を「テスト」扱いにする。
 */
(function () {
  var C = window.LMB;
  if (!C || !C.img) return;
  var LS = { get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } }, set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} } };
  var vid = LS.get('kabc_vid');
  if (!vid || !/^[A-Za-z0-9_-]{8,64}$/.test(vid)) {
    vid = (window.crypto && crypto.randomUUID ? crypto.randomUUID() : (Date.now().toString(36) + Math.random().toString(36).slice(2))).replace(/[^A-Za-z0-9_-]/g, '');
    LS.set('kabc_vid', vid);
  }
  var qs = new URLSearchParams(location.search);
  var preview = C.preview || qs.get('lmb') === '1';
  var device = window.matchMedia('(max-width: 749px)').matches ? 'sp' : 'pc';
  var path = ((preview ? '/__test__' : '') + location.pathname).slice(0, 200);
  var queue = [];
  function flush() {
    if (!queue.length || navigator.webdriver) { queue = []; return; }
    var ev = queue.splice(0, 20);
    try { fetch(C.endpoint, { method: 'POST', mode: 'cors', keepalive: true, headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify({ site: 'shop', vid: vid, device: device, path: path, ev: ev }) }).catch(function () {}); } catch (e) {}
  }
  setInterval(flush, 4000);
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') flush(); });
  window.addEventListener('pagehide', flush);

  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function card(slot) {
    var href = C.href + '?utm_source=shop&utm_medium=banner&utm_campaign=learn_mail_2026_10&utm_content=' + slot;
    var a = document.createElement('a');
    a.className = 'lmb-card';
    a.href = href;
    if (C.bg) a.style.backgroundImage = 'url("' + C.bg + '")';
    a.setAttribute('aria-label', C.title + ' ' + C.cta);
    a.innerHTML = '<span class="lmb-photo"><img src="' + esc(C.img) + '" alt="' + esc(C.alt) + '" loading="lazy" width="112" height="112"></span>'
      + '<span class="lmb-text"><span class="lmb-title">' + esc(C.title) + '</span><span class="lmb-lead">' + esc(C.lead) + '</span>'
      + '<span class="lmb-cta">' + esc(C.cta) + '</span></span>';
    var seen = false, hits = 0;
    a.addEventListener('click', function () { queue.push({ v: 'M', t: 'click', s: slot }); flush(); }, true);
    setInterval(function () {
      if (seen || document.visibilityState !== 'visible' || !a.offsetWidth) return;
      var r = a.getBoundingClientRect();
      var h = Math.min(r.bottom, innerHeight) - Math.max(r.top, 0), w = Math.min(r.right, innerWidth) - Math.max(r.left, 0);
      var on = h > 0 && w > 0 && (h * w) / (r.height * r.width) >= 0.5;
      hits = on ? hits + 1 : 0;
      if (hits >= 2) { seen = true; queue.push({ v: 'M', t: 'view', s: slot }); }
    }, 500);
    var wrap = document.createElement('div');
    wrap.className = 'lmb-wrap';
    wrap.appendChild(a);
    return wrap;
  }
  function after(el, node) { if (el && el.parentNode) el.parentNode.insertBefore(node, el.nextSibling); }

  // 商品ページ：おすすめ商品のセクションの前（商品説明と検定バナーのあと）
  var rec = document.querySelector('[id$="__product-recommendations"]');
  if (rec && /\/products\//.test(location.pathname)) rec.parentNode.insertBefore(card('learn_product'), rec);
  // 記事ページ：本文の末尾
  var body = document.querySelector('.article__body');
  if (body && /\/blogs\//.test(location.pathname)) after(body, card('learn_article'));
  // TOP：記事リスト（blog-posts）の下
  var blog = document.querySelector('[id$="__blog-posts"]');
  if (blog && (location.pathname === '/' || location.pathname === '')) after(blog, card('learn_top'));
})();
